export const security = {
  type: 'Security Doors',
  arType: 'أبواب امان',
  assets: [
    {
      id: 1,
      img: 'https://storage.googleapis.com/door-assets/site/security/MSD_2.jpg',
      title: '',
    },
    {
      id: 2,
      img: 'https://storage.googleapis.com/door-assets/site/security/MSD_20.jpg',
      title: '',
    },
    {
      id: 3,
      img: 'https://storage.googleapis.com/door-assets/site/security/MSD_5.jpg',
      title: '',
    },
    {
      id: 4,
      img: 'https://storage.googleapis.com/door-assets/site/security/MSD__3.jpg',
      title: '',
    },
    {
      id: 5,
      img: 'https://storage.googleapis.com/door-assets/site/security/M_1.jpg',
      title: '',
    },
    {
      id: 6,
      img: 'https://storage.googleapis.com/door-assets/site/security/M_22.jpg',
      title: '',
    },
    {
      id: 7,
      img: 'https://storage.googleapis.com/door-assets/site/security/M_38.jpg',
      title: '',
    },
    {
      id: 8,
      img: 'https://storage.googleapis.com/door-assets/site/security/SD_101',
      title: '',
    },
    {
      id: 9,
      img: 'https://storage.googleapis.com/door-assets/site/security/SD_G',
      title: '',
    },
    {
      id: 10,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG-1412.jpg',
      title: '',
    },
    {
      id: 11,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG-1420.jpg',
      title: '',
    },
    {
      id: 12,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG-1437.jpg',
      title: '',
    },
    {
      id: 13,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG-2522.jpg',
      title: '',
    },
    {
      id: 14,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG_4047.jpg',
      title: '',
    },
    {
      id: 15,
      img: 'https://storage.googleapis.com/door-assets/site/security/zsd_24.jpg',
      title: '',
    },
    {
      id: 16,
      img: 'https://storage.googleapis.com/door-assets/site/security/_DSC6869.jpg',
      title: '',
    },
    {
      id: 17,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG_1233.jpg',
      title: '',
    },
    {
      id: 18,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG_3941.jpg',
      title: '',
    },
    {
      id: 19,
      img: 'https://storage.googleapis.com/door-assets/site/security/IMG_4607.jpg',
      title: '',
    },
  ]
};
